import { operatorClient } from 'domain/HttpClients';

export const stopAllCredits = () => operatorClient.Post('/api/finance/credit-terms/stop-credits').send();
